
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import Button from '@/components/ui-elements/button';
import { Database } from '@/integrations/supabase/types';

type CustomerProfile = Database['public']['Tables']['customer_profiles']['Row'];

interface UserPointsFormProps {
  selectedUser: CustomerProfile;
  pointsToAdd: string;
  onPointsChange: (value: string) => void;
  onAddPoints: () => void;
}

const UserPointsForm: React.FC<UserPointsFormProps> = ({
  selectedUser,
  pointsToAdd,
  onPointsChange,
  onAddPoints
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {t('admin.addPointsTo')} {selectedUser.first_name} {selectedUser.last_name}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex gap-4 items-end">
          <div className="flex-1">
            <label className="block text-sm font-medium mb-1">{t('admin.points')}</label>
            <Input
              type="number"
              value={pointsToAdd}
              onChange={(e) => onPointsChange(e.target.value)}
              placeholder="10"
            />
          </div>
          <Button 
            onClick={onAddPoints}
            leftIcon={<Plus className="h-4 w-4" />}
          >
            {t('admin.addPoints')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default UserPointsForm;
